import React from 'react';
import { createFooterlessLayout } from 'apps/new-web/views/pages/create-layout';
import { connect } from 'react-redux';
import ScrollWrapper from 'apps/new-web/views/components/scroll-context';
import ActivateSignUpNav from '../sign-up/components/activate-signup-nav';
import I18n from 'apps/new-web/views/components/i18n';
import DownloadContent from '../app-download/components/download-content';

const DownloadNoEquipmentPage = () => {
  const noEquipmentData = {
    topLogo: true,
    header: I18n.translate('Download the [ifit] app.', { ifit: 'iFIT' }, 'Title instructing the user to download the ifit app.'),
    primaryCopy: I18n.translate('To start using [ifit], please download the [ifit] app. Sign in with the account you just created, then start a workout from the app.', { ifit: 'iFIT' }),
  };

  return (
    <div className="download-app-page">
      <ScrollWrapper>
        <ActivateSignUpNav link="/" />
        <section
          aria-label={ I18n.translate('Download [ifit] apps.', { ifit: 'iFIT' }, 'Header announcing this is where the user will download the app.' ) }
          className="download-page-content"
        >
          <div className="scrim" />
          <DownloadContent data={ noEquipmentData } />
        </section>
      </ScrollWrapper>
    </div>
  );
};

DownloadNoEquipmentPage.getAdditionalHeadTags = function() {
  return `<meta name="description" content="${ I18n.translate(
    'Get personal virtual fitness training from experts, whether you have [ifit]-enabled equipment, your own equipment, or no equipment! Download [ifit] apps now.',
    { 'ifit': 'iFIT' },
    'Invites user to join iFIT.'
  ) }" />`;
};


const ConnectDownloadNoEquipmentPage = connect((state) => {
  return {
    layout: state.layout,
  };
})(DownloadNoEquipmentPage);

export default createFooterlessLayout(ConnectDownloadNoEquipmentPage);
